
import { Vue } from "vue-class-component";

export default class BookingShipmentV2 extends Vue {}
